import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import Input from "../../components/Input";
import Select from "../../components/Select";

const EditTeamMemberModal = ({
  isOpen,
  onClose,
  editUserData,
  onSuccess,
  fetchTeam,
  api,
}) => {
  const [updatedUser, setUpdatedUser] = useState({});

  useEffect(() => {
    setUpdatedUser(editUserData);
  }, [editUserData]);

  const handleRoleChange = e => {
    setUpdatedUser(prev => ({ ...prev, role: e.target.value }));
  };

  const handleEditSaveUser = async e => {
    try {
      e.preventDefault();

      const userObj = {
        role: updatedUser.role,
      };

      await api.put(`/api/team/user/${updatedUser.id}`, userObj);

      await fetchTeam();
      onSuccess();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      onSubmit={handleEditSaveUser}
      open={isOpen}
      onClose={onClose}
      title="Manage team member"
      submitLabel="Save changes"
    >
      <div className="flex items-center space-x-2">
        {/* Email Input */}
        <div className="flex-1">
          <label className="text-sm text-gray-600">Email address</label>
          <Input value={updatedUser?.email || ""} disabled />
        </div>

        {/* Role Dropdown */}
        <div className="w-28">
          <label className="text-sm text-gray-600">Role</label>

          <Select
            value={updatedUser?.role || ""}
            onChange={handleRoleChange}
            options={[
              { value: "admin", label: "Admin" },
              { value: "member", label: "Member" },
            ]}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EditTeamMemberModal;
